import { render, staticRenderFns } from "./CiguangOppo.vue?vue&type=template&id=cfcd21b6&scoped=true&"
import script from "./CiguangOppo.vue?vue&type=script&lang=js&"
export * from "./CiguangOppo.vue?vue&type=script&lang=js&"
import style0 from "./CiguangOppo.vue?vue&type=style&index=0&id=cfcd21b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcd21b6",
  null
  
)

export default component.exports